import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-rejection-reason-dialog',
  templateUrl: './rejection-reason-dialog.component.html',
  styleUrls: ['./rejection-reason-dialog.component.scss']
})
export class RejectionReasonDialogComponent {
  @Input('appendTo') appendTo: string;
  show_Dialog: boolean = false;
  title: string = 'Reject Lead';
  rejectForm: FormGroup;
  is_form_submit: boolean = false;
  isLoading: boolean = false;

  @Output() onSuccess: EventEmitter<string> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter();

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    this.hide();
  }

  constructor(
    private readonly fb: FormBuilder
  ) { }

  initializeForm() {
    // Destroy the existing form completely
    this.rejectForm = null;

    // Create a new form
    this.rejectForm = this.fb.group({
      reason: ['', Validators.compose([Validators.required, Validators.maxLength(250)])],
    });

    // Reset all states
    this.is_form_submit = false;
    this.isLoading = false;
  }

  show() {
    this.show_Dialog = true;
    this.initializeForm();
  }

  hide() {
    this.is_form_submit = false;
    this.show_Dialog = false;
    this.isLoading = false;

    // Completely destroy the form
    this.rejectForm = null;

    this.onCancel.emit();
  }

  async handleSubmitForm() {
    this.is_form_submit = true;

    if (this.rejectForm && this.rejectForm.valid) {
      this.isLoading = true;
      const reason = this.rejectForm.get('reason')?.value;
      this.onSuccess.emit(reason);
      this.is_form_submit = false;
      this.hide();
      this.isLoading = false;
    }
  }

  handleCancelConfirm() {
    // Completely destroy the form
    this.rejectForm = null;
    this.is_form_submit = false;
    this.isLoading = false;
    this.hide();
  }
}
